import { action } from "mobx";
import Immersive3dTourUploadedPanoramaCheckRepository from "~/repository/Immersive3dTour/Immersive3dTourUploadedPanoramaCheckRepository";

class Immersive3dTourUploadedPanoramaCheckStore {
  /**
   * @property {Immersive3dTourUploadedPanoramaCheckRepository|null}
   */
  immersive3dTourUploadedPanoramaCheckRepository = null;

  constructor() {
    this.immersive3dTourUploadedPanoramaCheckRepository = new Immersive3dTourUploadedPanoramaCheckRepository();
  }

  @action
  getOne(data) {
    return this.immersive3dTourUploadedPanoramaCheckRepository.fetchOne(data);
  }
}

export default Immersive3dTourUploadedPanoramaCheckStore;
